import { styled } from '@mui/material/styles';
import { Box, Chip } from '@mui/material';

export const AboutContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(5, 2), // Reduced padding overall
    position: 'relative',
    backgroundColor: 'rgba(46, 54, 73, 0.6)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(10, 4), // Restore larger padding on medium screens and up
    },
}));

export const AboutImage = styled('img')(({ theme }) => ({
    width: '100%',
    maxWidth: '240px', // Slightly smaller on mobile
    height: 'auto',
    objectFit: 'contain',
    borderRadius: '50%',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
    display: 'block',
    margin: '0 auto',
    marginBottom: theme.spacing(4), // Add bottom margin for mobile
    [theme.breakpoints.up('md')]: {
        maxWidth: '300px', // Return to original size on larger screens
        marginBottom: 0, // Remove bottom margin on larger screens
    },
}));

export const ContactChipsContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    justifyContent: 'center', // Center by default for all screens
    width: '100%', // Ensure the container takes full width
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
        gap: theme.spacing(2),
        justifyContent: 'flex-start', // Only align left on larger screens
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
}));

export const ContactChip = styled(Chip)(({ theme }) => ({
    padding: theme.spacing(1),
    height: 'auto',
    transition: 'all 0.2s ease',
    '& .MuiChip-label': {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 1.5),
        whiteSpace: 'normal',
    },
    '&:hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    },
}));
